module.exports = __webpack_public_path__ + "static/Danielle_Wheeler-b2c2023d93bc9cee4c385b905b7ec46a.webp";